import { BASE, axiosCall, MethodType } from "./base";
import store from "@/store";

const DATASTORE_BASE = `https://courses.ecampus.oregonstate.edu/services/datastore/public/`;
const DATASTORE_ENTRY = `${DATASTORE_BASE}v1/entry`;
const DATASTORE_ENTRIES = `${DATASTORE_BASE}v1/entries`;

/**
 * Performs a preflight check and prepares the payload for API calls.
 *
 * @param {Object} payload - The payload for the API request.
 * @returns {Object|undefined} - The modified payload or undefined if preflight fails.
 */
function preflight(payload = {}) {
  if (!BASE) {
    console.error("[API] Base API URL is not set.");
    return;
  }

  if (!store.getters.useAuth) {
    console.warn("Attempting call without public_key.");
    return false;
  }

  if (!store.getters.useDatastore) {
    console.warn("Attempting call without using Datastore");
    return false;
  }

  if (!store.getters.publicKey) {
    console.warn("Attempting call without public_key.");
  }

  if (!store.getters.getToken) {
    console.error("Attempting call without token.");
    return false;
  }

  return payload;
}

function readEntry() {
  let payload = preflight();
  if (!payload) {
    console.error("[API] Read Datastore Entry could not run.");
    return Promise.reject(new Error("Preflight failed"));
  }

  let url = `${DATASTORE_ENTRY}?public_key=${store.getters.publicKey}`;

  return axiosCall(MethodType.GET, url);
}

function readEntries() {
  let payload = preflight();
  if (!payload) {
    console.error("[API] Read Datastore Entry could not run.");
    return Promise.reject(new Error("Preflight failed"));
  }

  let url = `${DATASTORE_ENTRIES}?public_key=${store.getters.publicKey}`;

  return axiosCall(MethodType.GET, url)
    .then((response) => {
      //console.log("Read Entries Response:", response);
      return response;
    })
    .catch((error) => {
      console.error("Error in Read Entries:", error.response?.data || error);
      throw error;
    });
}

export { readEntry, readEntries };
